module.exports = {"apiKeys":{"testKeys":""},"mmoDevs":["Jonas Dahlin","Emma Bok","Oskar Madestam","Fredrik Helgodt","Valentin Cvetkovski"]}


//////////////////
// WEBPACK FOOTER
// ./src/json/config.json
// module id = 88
// module chunks = 0